import { AuditOutlined } from '@ant-design/icons';
import React from 'react';
import { TermsOfServiceLink } from '@ui/links';
export const termsMenuItem = {
    icon: React.createElement(AuditOutlined, null),
    id: 'terms-menu-item',
    key: 'Terms of Service',
    label: React.createElement(TermsOfServiceLink, null)
};
